/* eslint-disable prettier/prettier */
import React, { useEffect } from 'react';
import { Route, Navigate, useNavigate } from 'react-router-dom';
import { Routes } from 'react-router-dom';
import Home from './pages/Home';
import Layout from './components/Layout';
import Login from './pages/Login';
// import TemporyBlock from './pages/TemporyBlock';
// import MaintenancePage from './pages/MaintenancePage';
import ContributionFirstPage from './pages/ContributionFirstPage';
import OtpAuthenticationpage from './pages/OtpAuthenticationPage';
import { useSelector } from 'react-redux';
import TransectionStatusPage from './pages/TransectionStatusPage';
import ContributionHistory from './pages/ContributionHistory';
import AboutBSG from './pages/FotterPages/AboutBSG';
import ContactUs from './pages/FotterPages/ContactUs';
import TermsOfUse from './pages/FotterPages/TermsOfUse';
import Delivery from './pages/FotterPages/Delivery';
import CancellationPolicy from './pages/FotterPages/CancellationPolicy';
import ContributionForm10BEListing from './pages/ContributionForm10BEListing';
import Forgot from './pages/ForgotPassword/forgotPassword';
import ChangePassword from './pages/ForgotPassword/changePassword';
import ReactGA from 'react-ga4';

const AppRouter = () => {
  const PrivateRoute = () => {
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated); // determine if authorized, from context or however you're doing it

    // If authorized, return an outlet that will render child elements
    // If not, return element that will navigate to login page
    return isAuthenticated ? <Layout /> : <Navigate to="/login" />;
  };
  const navigate = useNavigate();
  useEffect(() => {
    ReactGA.initialize('G-1T2W8QFWPV');
    // ReactGA.pageview(window.location.pathname);
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname,
    });
    return navigate((location) => {
      ReactGA.set({ page: location.pathname });
      // ReactGA.pageview(location.pathname);
      ReactGA.send({
        hitType: 'pageview',
        page: location.pathname,
      });
    });
  }, [navigate]);
  useEffect(() => {
    ReactGA.initialize('G-1T2W8QFWPV');
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-1T2W8QFWPV';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [navigate]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route exact path="/" element={<PrivateRoute />}>
        <Route exact path="/" element={<Home />} />
        <Route
          exact
          path="/contribution-first-page"
          element={<ContributionFirstPage />}
        />
        {/* <Route
          exact
          path="/payment-gateway-page"
          element={<PaymentGatewayPage />}
        /> */}
        <Route
          path="/online-transection-status/*"
          element={<TransectionStatusPage />}
        />
        <Route
          exact
          path="/contribution-history"
          element={<ContributionHistory />}
        />
        <Route
          exact
          path="/form10be-listing"
          element={<ContributionForm10BEListing />}
        />
      </Route>
      {/* Temporarly block login page 25-03-2026 to 31-03-2026 */}
      {/* <Route exact path="/login" element={<Login />} /> */}
      {/* <Route exact path="/login" element={<TemporyBlock />} /> */}
      {/*<Route exact path="/login" element={<MaintenancePage />} />*/}
      <Route exact path="/AboutUs" element={<AboutBSG />} />
      <Route exact path="/ContactUs" element={<ContactUs />} />
      <Route exact path="/TermsOfUse" element={<TermsOfUse />} />
      <Route exact path="/DeliveryAndShipment" element={<Delivery />} />
      <Route exact path="/Termcondition" element={<CancellationPolicy />} />
      <Route
        exact
        path="/otp-authentication"
        element={<OtpAuthenticationpage />}
      />
      <Route exact path="/home" element={<Home />} />
      <Route path="/forgot-password" element={<Forgot />} />
      <Route
        path="/ChangePassword/:memberId/:authToken"
        element={<ChangePassword />}
      />
    </Routes>
  );
};

export default AppRouter;
